import { useState } from "react";
import { api, formatApiError } from "@/lib/apiClient";
import { toast } from "sonner";
import { Mail, Send } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/newsletter", { email, name: name || null });
      trackEvent("newsletter_signup");
      toast.success(data.message);
      setEmail(""); setName("");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Subscription failed.");
    } finally { setBusy(false); }
  };

  return (
    <section className="relative bg-onyx border-t border-white/10 grain overflow-hidden" data-testid="newsletter-section">
      <div className="max-w-4xl mx-auto px-5 md:px-8 py-24 text-center">
        <Mail className="text-gold mx-auto mb-6" size={36} strokeWidth={1.5} />
        <p className="text-xs uppercase tracking-[0.3em] text-gold mb-4">Join the Awakening</p>
        <h2 className="font-serif text-4xl md:text-5xl text-bone mb-4 leading-tight">Receive the Sacred Dispatch</h2>
        <p className="text-bone/60 max-w-xl mx-auto mb-10 text-lg">
          New teachings, class announcements and In-Sight concepts delivered to your inbox. Free for every seeker.
        </p>
        <form onSubmit={submit} className="max-w-xl mx-auto flex flex-col sm:flex-row gap-3" data-testid="newsletter-form">
          <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name (optional)"
            data-testid="newsletter-name"
            className="flex-1 bg-black/50 border border-white/10 px-4 py-3 text-bone placeholder:text-bone/30 focus:outline-none focus:border-gold/50" />
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email"
            data-testid="newsletter-email"
            className="flex-1 bg-black/50 border border-white/10 px-4 py-3 text-bone placeholder:text-bone/30 focus:outline-none focus:border-gold/50" />
          <button type="submit" disabled={busy} data-testid="newsletter-submit"
            className="bg-gold text-black px-7 py-3 font-medium hover:bg-gold2 transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
            <Send size={16} /> {busy ? "..." : "Subscribe"}
          </button>
        </form>
      </div>
    </section>
  );
}
